import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconVolumeUp } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openSettingsDialog } from "../../../settings/actions.web";
import { SETTINGS_TABS } from "../../../settings/constants";
/**
 * Implementation of a button for accessing chat pane.
 */
class AudioSettingsButtonMobile extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = this.props._hasPermissions ? 'settings.audio' : 'settings.audioNoPermissions';
        this.icon = IconVolumeUp;
        this.label = this.props._hasPermissions ? 'settings.audio' : 'settings.audioNoPermissions';
        this.containerClassName = 'last-context-menu-item';
    }
    /**
     * Indicates whether this button is in disabled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return this.props._lobbyKnocking || !this.props._hasPermissions;
    }
    /**
     * Overrides AbstractButton's {@link Component#render()}.
     *
     * @override
     * @protected
     * @returns {boReact$Nodeolean}
     */
    render() {
        return (React.createElement(React.Fragment, null, super.render()));
    }
    /**
     * Handles clicking the button, and toggles the chat.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(openSettingsDialog(SETTINGS_TABS.AUDIO));
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    const { knocking } = state['features/lobby'];
    const { permissions } = state['features/base/devices'];
    return {
        _lobbyKnocking: knocking,
        _hasPermissions: permissions.audio,
    };
};
export default translate(connect(mapStateToProps)(AudioSettingsButtonMobile));
